<template>
  <div>
    <div style="w-100">
      <div class="d-flex" style="position: absolute; z-index: 2 !important">
        <Button
          :size="15"
          color="#fd7e14"
          colorText="#ffffff"
          tooltip="Filtrar contenido"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal')"
          traslate
        />
        <Button
          :size="15"
          color="#dc3545"
          colorText="#ffffff"
          tooltip="Borrar contenido Filtrado"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          traslate
          @click.native="clear()"
        />
      </div>
    </div>

    <ui-modal ref="modal" title="Filtros para tabla" size="auto">
      <!-- Cuerpo -->
      <div class="d-flex flex-column">
        <!-- Fila 1 -->
        <div class="d-flex flex-column">
          <div class="d-flex">
            <!-- ID Booking -->
            <ui-textbox
              class="w-50 mr-3"
              label="ID Booking"
              placeholder="Ingrese ID Booking"
              v-model="idBookingModel"
            ></ui-textbox>

            <!-- Referencia -->
            <ui-textbox
              label="Referencia"
              placeholder="Ingrese Referencia"
              class="w-50 mr-3"
              v-model="referenciaModel"
            ></ui-textbox>

            <!-- Número de booking -->
            <ui-textbox
              class="w-50 mr-3"
              label="Número de booking"
              placeholder="Ingrese Número Booking"
              v-model="nroBookingModel"
            ></ui-textbox>

            <!-- Cliente -->
            <ui-select
              class="w-50 mr-3"
              has-search
              label="Cliente"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              :options="dataListaCliente"
              v-model="clienteBookingModel"
            ></ui-select>
          </div>

          <div class="d-flex">
            <!-- Nave -->
            <ui-textbox
              class="w-50 mr-3"
              has-search
              label="Nave"
              placeholder="Ingresar Nave"
              v-model="naveModel"
            ></ui-textbox>

            <!-- Naviera -->
            <ui-select
              class="w-50 mr-3"
              has-search
              label="Naviera"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              :options="navieras"
              v-model="navieraModel"
            ></ui-select>

            <!-- Puerto de Descarga (POD) -->
            <ui-select
              class="w-50 mr-3"
              has-search
              label="Puerto de Descarga (POD)"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              :options="dataListaPOD"
              v-model="podModel"
            ></ui-select>

            <!-- Puerto de Carga (POL) -->
            <ui-select
              has-search
              class="w-50 mr-3"
              label="Puerto de Carga (POL)"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              :options="dataListaPOL"
              v-model="polModel"
            ></ui-select>
          </div>

          <div class="d-flex">
            <!-- Desde semana -->
            <ui-select
              class="w-50 mr-3"
              has-search
              label="Desde Semana"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              :options="dataListaSemana"
              v-model="semanaInicioModel"
            ></ui-select>

            <!-- Hasta semana -->
            <ui-select
              class="w-50 mr-3"
              has-search
              label="Hasta Semana"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              :options="dataListaSemana"
              v-model="semanaTerminoModel"
            ></ui-select>

            <!-- Año -->
            <ui-select
              class="w-50 mr-3"
              has-search
              label="Año"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              :options="dataListaAnio"
              v-model="anioModel"
            ></ui-select>

            <div class="w-50"></div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-between mt-5">
        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>
        <div style="float: right">
          <button
            class="btn btn-secondary"
            style="margin-right: 50px"
            @click="clear"
          >
            Limpiar
          </button>
          <button class="btn btn-danger mr-3" @click="filtrarLista" :disabled="!filter_btn_active">
            {{ filter_btn_text }}
          </button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";
import UiSelect from "keen-ui/src/UiSelect";
import Button from "../../../common/Button";
import { mapActions, mapState } from "vuex";

import { getBookingsPorConfirmarFiltrados } from "@/constants/lineas";
// Buttom

export default {
  data() {
    return {
      // Modelos
      referenciaModel: "",
      idBookingModel: "",
      nroBookingModel: "",
      clienteBookingModel: "",
      naveModel: "",
      navieraModel: "",
      podModel: "",
      polModel: "",
      semanaInicioModel: "",
      semanaTerminoModel: "",
      anioModel: "",
      filter_btn_text: "Filtrar",
      filter_btn_active: true,
      //Filter
      dataFilter: this.dataDatatableBookingsPorConfirmarFiltrada,
    };
  },
  components: {
    UiModal,
    UiSelect,
    UiTextbox,
    Button,
  },
  computed: {
    ...mapState("lineas", [
      "dataDatatableBookingsPorConfirmarFiltrada",
      "dataListaPOD",
      "dataListaNave",
      "dataListaSemana",
      "dataListaPOL",
      "dataListaAnio",
      "dataListaCliente",
    ]),
    ...mapState([
      "navieras",
    ]),
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetDatatableBookingsPorConfirmar",
      "actionFilterDataBookingsPorConfirmar",
      "actionLimpiarDataBookingsPorConfirmar",
    ]),

    clear() {
      this.nroBookingModel = "";
      this.referenciaModel = "";
      this.idBookingModel = "";
      this.clienteBookingModel = "";
      this.naveModel = "";
      this.navieraModel = "";
      this.podModel = "";
      this.polModel = "";
      this.semanaInicioModel = "";
      this.semanaTerminoModel = "";
      this.anioModel = "";
      this.actionLimpiarDataBookingsPorConfirmar();
      this.loadingButton(true);
    },
    async filtrarLista() {

      this.loadingButton(false);

      this.actionLimpiarDataBookingsPorConfirmar();

      let filters = {
        id: this.idBookingModel ?? null,
        referencia: this.referenciaModel ?? null,
        no_booking: this.nroBookingModel ?? null,
        cliente: this.clienteBookingModel.id ?? null,
        nave: this.naveModel ?? null,
        naviera: this.navieraModel.id ?? null,
        pod: this.podModel.id ?? null,
        pol: this.polModel.id ?? null,
        semana_inicio: this.semanaInicioModel.id ?? null,
        semana_termino: this.semanaTerminoModel.id ?? null,
        anio: this.anioModel ?? null
      };

      let dataFiltrada = await getBookingsPorConfirmarFiltrados(filters);

      this.actionFilterDataBookingsPorConfirmar(dataFiltrada);

      this.loadingButton(true);

      this.closeModal("modal");
    },
    loadingButton(active) {
      if (!active) {
        this.filter_btn_text = "Filtrando...";
        this.filter_btn_active = active;
      } else {
        this.filter_btn_text = "Filtrar";
        this.filter_btn_active = active;
      }
    },
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
  },
};
</script>

<style>
.ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
  width: 80rem;
}
</style>
